import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV_CONFIG_TOKEN } from '../shared/config';
import { ContactInformation } from './model/contact-information';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  #config = inject(ENV_CONFIG_TOKEN);
  private static baseUrl: string;
  private static patientUrl: string;
  private static providerUrl: string;
  private static list = '/list';
  private static patientListUrl: string;
  private static providerListUrl: string;

  constructor(private http: HttpClient) {
    ContactService.baseUrl = `${this.#config.apiBaseUrl}/contact`;
    ContactService.patientUrl = `${ContactService.baseUrl}/patient`;
    ContactService.providerUrl = `${ContactService.baseUrl}/provider`;
    ContactService.patientListUrl = `${ContactService.patientUrl}${ContactService.list}`;
    ContactService.providerListUrl = `${ContactService.providerUrl}${ContactService.list}`;
  }

  public getPatientContactInformation(id: string): Observable<ContactInformation> {
    return this.getContactInformation(id, ContactService.patientUrl);
  }

  public getProviderContactInformation(id: string): Observable<ContactInformation> {
    return this.getContactInformation(id, ContactService.providerUrl);
  }

  private getContactInformation(id: string, url: string): Observable<ContactInformation> {
    return this.http.get<ContactInformation>(`${url}?id=${id}`);
  }

  public savePatientContactInformation(
    contactInformation: ContactInformation,
  ): Observable<ContactInformation> {
    return this.saveContactInformation(contactInformation, ContactService.patientUrl);
  }

  public saveProviderContactInformation(
    contactInformation: ContactInformation,
  ): Observable<ContactInformation> {
    return this.saveContactInformation(contactInformation, ContactService.providerUrl);
  }

  private saveContactInformation(
    contactInformation: ContactInformation,
    url: string,
  ): Observable<ContactInformation> {
    return this.http.post<ContactInformation>(url, contactInformation);
  }

  public listPatientContactInformation(id: string): Observable<ContactInformation[]> {
    return this.listContactInformation(id, ContactService.patientListUrl);
  }

  public listProviderContactInformation(id: string): Observable<ContactInformation[]> {
    return this.listContactInformation(id, ContactService.providerListUrl);
  }

  private listContactInformation(id: string, url: string): Observable<ContactInformation[]> {
    return this.http.get<ContactInformation[]>(`${url}?id=${id}`);
  }

  public deletePatientContactInformation(id: string): Observable<void> {
    return this.deleteContactInformation(id, ContactService.patientUrl);
  }

  public deleteProviderContactInformation(id: string): Observable<void> {
    return this.deleteContactInformation(id, ContactService.providerUrl);
  }

  private deleteContactInformation(id: string, url: string): Observable<void> {
    return this.http.delete<void>(`${url}/${id}`);
  }
}
